export const validateCurrentInputValue = (value: string) =>
  value.trimStart().replace(/[ ]{2,}/gi, ' ');
